import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Building2, Route, Bike, Settings } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const SolutionsSection = () => {
  const { t } = useLanguage();

  const icons = [Building2, Route, Bike, Settings];

  return (
    <section id="soluciones" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ color: '#1F4FD8' }}>
            {t.solutions.title}
          </h2>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.solutions.items.map((item, index) => {
            const IconComponent = icons[index];
            return (
              <Card
                key={index}
                className="group bg-white border border-slate-200 hover:border-blue-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <CardContent className="p-6">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#1F4FD8', boxShadow: '0 8px 20px rgba(31, 79, 216, 0.2)' }}>
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-4">
                    {item.title}
                  </h3>
                  <ul className="space-y-2">
                    {item.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start gap-2 text-sm text-slate-600">
                        <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#1F4FD8' }} />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
